import useQueryParams from '@common/src/hooks/useQueryParams';
import FlowProductsSidebar, {
  FlowProductsSidebarItem,
} from '@flows/src/components/flow-products/FlowProductsSidebar';
import AnvaProductCartWidget from '@flows/src/components/flow-products/quotes/cart/AnvaProductCartWidget';
import AnvaFlowProductsSideBarBasketPriceSummary from '@flows/src/components/flow-products/AnvaFlowProductsSideBarBasketPriceSummary';
import AnvaFlowProductsSideBarBasketItems from '@flows/src/components/flow-products/sidebar/AnvaFlowProductsSideBarBasketItems';
import { useAnvaQuotesWithPolling } from '@flows/src/hooks/flow-products';

const AnvaFlowProductsSidebar = () => {
  const queryParams = useQueryParams();
  const sessionId = queryParams.get('session_id') || undefined;

  // we need risk_object_name info, which is only returned on job finish
  const { data } = useAnvaQuotesWithPolling({
    sessionId,
    enabled: !!sessionId,
  });
  const isBasketPage = window.location.pathname.includes('basket');

  const sideBarItems: FlowProductsSidebarItem[] = data?.navigationMap || [];

  return (
    <FlowProductsSidebar
      items={sideBarItems}
      isHidden={window.location.pathname.includes('selection-overview')}
      cartComponent={
        isBasketPage ? (
          <AnvaFlowProductsSideBarBasketPriceSummary />
        ) : (
          <AnvaProductCartWidget />
        )
      }
      basketItemsComponent={<AnvaFlowProductsSideBarBasketItems />}
    />
  );
};

export default AnvaFlowProductsSidebar;
